/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import { smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { SunriseIcon } from '../../common/icons/sunriseIcon';
import { ILocationSolarDateTime } from './types';
import { datesAreSameDay, formatDateStr, hourMinDateFormat } from './utils';
import { reduxConnect } from '../../../common';

export const getSolarPeriod = (hourlyCardLocalDate: string, locSolarDateTime: ILocationSolarDateTime[]): ILocationSolarDateTime | undefined => {
    return locSolarDateTime?.find(solarDateItem => datesAreSameDay(hourlyCardLocalDate, solarDateItem.SunriseDateTimeLocal, 'day'));
};

export const isSunriseSunsetHour = (sunriseSunsetDateTimeLocal: string, hourlyForecastDateLocalStr: string): boolean => {

    if (sunriseSunsetDateTimeLocal && hourlyForecastDateLocalStr) {
        const solarDate = new Date(sunriseSunsetDateTimeLocal);
        const solarDateHours = solarDate.setHours(solarDate.getHours());
        const forecastCardDate = new Date(hourlyForecastDateLocalStr);
        const subtractHourFromForecastDate = forecastCardDate.setHours(forecastCardDate.getHours() - 1);
        const addHourToForecastDate = forecastCardDate.setHours(forecastCardDate.getHours() + 1);
        return solarDateHours >= subtractHourFromForecastDate && solarDateHours <= addHourToForecastDate;
    }
    return false;
};

interface SolarDivideProps {
    hourCardIndex: number;
    forecastDateLocalStr: string;
    locationSolarDateTime?: ILocationSolarDateTime[];
}

const mapStoreStateToProps = (storeState: any) => {
    const { solar } =  storeState || {};

    return {
        locationSolarDateTime: solar?.solarData
    };
};

const mapDispatchToProps = {};

export const SolarDivide = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ 
    hourCardIndex, 
    forecastDateLocalStr, 
    locationSolarDateTime = [] }: SolarDivideProps) => {

    let isSunriseHour = false;
    let isSunsetHour = false;
    let solarPeriod: ILocationSolarDateTime | undefined;

    if (locationSolarDateTime?.length) {
        solarPeriod = getSolarPeriod(forecastDateLocalStr, locationSolarDateTime);
        isSunriseHour = isSunriseSunsetHour(solarPeriod?.SunriseDateTimeLocal as string, forecastDateLocalStr);
        isSunsetHour = isSunriseSunsetHour(solarPeriod?.SunsetDateTimeLocal as string, forecastDateLocalStr);
    }

    if (!(solarPeriod && (isSunriseHour || isSunsetHour))) {
        return null;
    }

    const sunriseTime = isSunriseHour ? formatDateStr(solarPeriod?.SunriseDateTimeLocal, hourMinDateFormat) : '';
    const sunsetTime = isSunsetHour ? formatDateStr(solarPeriod?.SunsetDateTimeLocal, hourMinDateFormat) : '';

    const sunriseSunsetTime = sunriseTime || sunsetTime;

    return (
        <Container key={`${sunriseSunsetTime}-${hourCardIndex}`}>
            <SolarIconWrapper>
                <SunriseIcon width={30} height={30} />
            </SolarIconWrapper>
            <SolarTime>
                {sunriseSunsetTime?.toLowerCase()}
            </SolarTime>
        </Container>
    );
}));

const Container = styled.li`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 10px;
    align-items: center;
    height: 260px;
    width: 63px;
    min-width: 63px;
    @media ${smallMediaQuery} {
        flex-direction: row;
        height: 63px;
        width: 100%;
        min-width: 100%;
        padding: 4px 0;
        margin-bottom: 4px;
    }
`;

const SolarIconWrapper = styled.span`
    display: flex;
    justify-content: center;
    width: 34px;
    height: 17px;
    overflow: hidden;
`;

const SolarTime = styled.span`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 15px;
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    margin-top: 3px;
    @media ${smallMediaQuery} {
        height: 100%;
        margin-top: 0;
        margin-left: 7px;
    }
`;